import React, { useState } from 'react'
import { Card, Button, Form } from 'react-bootstrap';
import { useNavigate } from "react-router-dom";
import { axiosOpen } from '../../../../api/axios';
import { toast, Toaster } from 'react-hot-toast';


const AddSubscription = () => {
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [amount, setAmount] = useState("");
  const [description, setDescription] = useState("");
  const [listings, setListings] = useState("");
  const [loading, setLoading] = useState(false);
  const userID = localStorage.userID && JSON.parse(localStorage.userID);


  const handleSubmit = (event) => {
    event.preventDefault();
    if (name === "" || amount === "" || description === "" || listings === "")
      return false;
    (async () => {
      try {
        setLoading(true);
        const response = await axiosOpen.post(`subscription/create/${userID}`, {
          name,
          description,
          amount,
          "currency": "USD",
          "interval": "month", 
          listings
        });
        setLoading(false);
        toast.success('Subscription Plan Saved.');
        setTimeout(() => navigate("/subscription/list", { replace: true }), 3000);
      } catch (error) {
        setLoading(false);
        toast.error(error.response.data.message || "Oops! something went wrong.")
      }
    })();
  };

  const handleCancel = () => navigate("/subscription/list", { replace: true });

  return (
    <div className='wrapper'>
      <Card>
        <Card.Header><h4>Add Subscription Plan</h4></Card.Header>
        <Card.Body>
          <Form onSubmit={handleSubmit}>
            <Form.Group controlId="name" className="mb-2">
              <Form.Label>Name</Form.Label>
              <Form.Control type="text" value={name} onChange={(event) => setName(event.target.value)} required />
            </Form.Group>
            <Form.Group controlId="amount" className="mb-2">
              <Form.Label>Amount</Form.Label>
              <Form.Control type="number" value={amount} onChange={(event) => setAmount(event.target.value)} required />
            </Form.Group>
            <Form.Group controlId="description" className="mb-2">
              <Form.Label>Description</Form.Label>
              <Form.Control type="text" value={description} onChange={(event) => setDescription(event.target.value)} required />
            </Form.Group>
            <Form.Group controlId="listings" className="mb-2">
              <Form.Label>Listing</Form.Label>
              <Form.Control type="number" value={listings} onChange={(event) => setListings(event.target.value)} required />
            </Form.Group>
            <div className='btns-group'>
              <Button
                type="submit"
                variant="primary"
                className='btn-custom'
                disabled={loading}
              >
                {loading ? 'Saving..' : 'Save'}
              </Button>
              <Button
                variant="secondary"
                className='btn-custom'
                onClick={handleCancel}
              >
                Cancel
              </Button>
            </div>
          </Form>
        </Card.Body>
      </Card>
      <Toaster
        position="top-right"
        reverseOrder={false}
      />
    </div>
  )
}

export default AddSubscription